import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { HiArrowUpRight } from "react-icons/hi2";

const NAV_ITEMS = [
  { to: "/", label: "Home", index: "01" },
  { to: "/about", label: "About", index: "02" },
  { to: "/services", label: "Services", index: "03" },
  { to: "/project", label: "Projects", index: "04" },
  { to: "/shopify-portfolio", label: "Shopify", index: "05" },
  { to: "/blog", label: "Blog", index: "06" },
  { to: "/resume", label: "Resume", index: "07" },
  { to: "/contact", label: "Contact", index: "08" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.classList.toggle("no-scroll", open);
    return () => document.body.classList.remove("no-scroll");
  }, [open]);

  return (
    <>
      <header className={`nav ${scrolled ? "nav--scrolled" : ""}`}>
        <div className="container-x nav__inner">
          <Link to="/" className="nav__brand" aria-label="Oguzhan Ozcelik — Home">
            <span className="mark">O</span>
            <span>
              <span className="name">Oguzhan Ozcelik</span>
              <span className="role">Full-Stack · Shopify</span>
            </span>
          </Link>

          <nav className="nav__menu" aria-label="Primary">
            {NAV_ITEMS.map((it) => (
              <NavLink
                key={it.to}
                to={it.to}
                end={it.to === "/"}
                className={({ isActive }) => (isActive ? "active" : undefined)}
              >
                {it.label}
              </NavLink>
            ))}
          </nav>

          <div className="nav__cta">
            <Link
              to="/contact"
              className="btn nav__cta-btn"
              aria-label="Open contact form"
            >
              Let's talk
              <span className="arrow"><HiArrowUpRight /></span>
            </Link>
            <button
              type="button"
              aria-label={open ? "Close menu" : "Open menu"}
              aria-expanded={open}
              className={`nav__toggle ${open ? "open" : ""}`}
              onClick={() => setOpen((v) => !v)}
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </header>

      <div className={`nav__drawer ${open ? "open" : ""}`} aria-hidden={!open}>
        {NAV_ITEMS.map((it) => (
          <Link key={it.to} to={it.to}>
            {it.label}
            <span>{it.index}</span>
          </Link>
        ))}
      </div>
    </>
  );
}
